import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { WmsOrderDetailDto, WmsOrderHeaderDto } from "src/dtos/wmsOrder/wmsOrderDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS1021_R01Dto {
	wmsOrderHeaderDto: WMS1021_R01HeaderDto;
	wmsOrderDetailDtoList: WMS1021_R01DetailDto[];
	wmsStockLotDtoList: Record<string, WMS1021_R01LotDto[]>;
}

export interface WMS1021_R01HeaderDto extends WmsOrderHeaderDto {
	warehouseNm: string;
}

export const defaultWMS1021_R01HeaderDto: WMS1021_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	compCd: '',
	compNm: '',	
	logicCenter: '',
	orderDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '110', // 입고구분값 110으로 고정(구매입고)
	customCd: '',
	customNm: '',
	deadlineDt: formatDate(new Date()),
	inoutMethod: '',
	empNo: '',
	empNm: '',
	orderAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	inoutStatus: '',
	approveFlg: '',
	closeTag: 'N',
	remark: '',

	warehouseCd: '', // 창고코드
	warehouseNm: '', // 창고명

	inserted: false,
	isModified: false
}

export interface WMS1021_R01DetailDto extends WmsOrderDetailDto {
	dcAmt: number;
	updateTransportQty: number;
	orderQtyView: number;
	locationCd?: string;
	locationNm?: string;
}

export const defaultWMS1021_R01DetailDto: WMS1021_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	itemNo: '',
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	itemSeq: 0,
	itemCd: '',
	itemStatus: '',
	orderUnit: '',
	orderQty: 0,
	cancelQty: 0,
	orderPrice: 0,
	orderAmt: 0,
	transportQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	updateTransportQty: 0,
	dcAmt: 0,
	orderQtyView: 0,
	locationCd: '',
	locationNm: '',

	inserted: false,
	isModified: false
}

export interface WMS1021_R01LotDto extends WmsStockLotDto {
	lotInputOption: string;
	printed: boolean;
}

export const defaultWMS1021_R01LotDto: WMS1021_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',	
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	lotInputOption: 'N',
	printed: false,

	inserted: false,
	isModified: false,
}
